import { Spin } from "antd";
import { BillingTier } from "@prisma/client";

type Props = {
  free: any;
  pro: any;
  business: any;
  tier: BillingTier;
  loading: boolean;
};
export default function Paywall({ free, pro, business, tier, loading }: Props) {
  const platform = localStorage.getItem("platform");
  if (loading) {
    return (
      <div className="flex flex-1 items-center justify-center mt-20">
        <Spin />
      </div>
    );
  }

  if (platform === "slack") return pro;

  switch (tier) {
    case "pro":
      return pro;
    case "custom":
    case "business":
      return business;
    default:
      return free;
  }
}
